import type { Notification } from "@circle-react/types/Notification";
import { Link, useLocation } from "@tanstack/react-router";

import { useNavigateToPost } from "@/react/components/PostsV3/PostModal/hooks/useNavigateToPost";
import { usePostNavigationContext } from "@/react/components/PostsV3/PostViewList/PostNavigationContext";
import { usePostModalParamsFromPathname } from "@/react/hooks/usePostModalParams";

import { DefaultNotificationContent } from "./DefaultNotificationContent";

export const CommentNotification = ({
  notification,
  onClickHandler,
  isMarkedAsRead,
  shouldFocusOnCommentsSection,
}: {
  notification: Notification;
  onClickHandler: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  isMarkedAsRead: boolean;
  shouldFocusOnCommentsSection: boolean;
}) => {
  const pathname = useLocation({ select: location => location.pathname });

  const [actionPath, commentHash = ""] =
    notification.action_web_path?.split("#") ?? [];
  const isOnSamePage = actionPath === pathname;
  const postModal = usePostModalParamsFromPathname(
    notification.action_web_path,
  );

  const { navigateToPost } = useNavigateToPost();
  const { params, hasNextPage } = usePostNavigationContext();

  if (isOnSamePage) {
    return (
      <a
        href={notification.action_web_path}
        onClick={onClickHandler}
        className="w-full"
      >
        <DefaultNotificationContent
          notification={notification}
          isMarkedAsRead={isMarkedAsRead}
        />
      </a>
    );
  }

  return (
    <Link
      to={notification.action_web_path}
      state={{ from: { path: "/notifications" } }}
      className="w-full"
    >
      <button
        type="button"
        onClick={(event: any) => {
          onClickHandler(event);
          if (event.metaKey || event.ctrlKey) {
            return;
          }
          if (!postModal) return;
          event.preventDefault();
          navigateToPost({
            postModal,
            params,
            hasNextPage,
            hash: commentHash,
            shouldFocusOnCommentsSection: shouldFocusOnCommentsSection,
            shouldDisableNavigation: true,
          });
        }}
        className="w-full text-left"
      >
        <DefaultNotificationContent
          notification={notification}
          isMarkedAsRead={isMarkedAsRead}
        />
      </button>
    </Link>
  );
};
